import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../gori/components'
import {FlightInfo} from '../../definitions'
import {durationToString, splitDateTime, splitHours} from '../../utils'
import {isNumber} from 'lodash'

type FlightInfoCardProps = {
  flight: FlightInfo
  isLayover?: boolean
}
export const FlightInfoCard = ({flight, isLayover = false}: FlightInfoCardProps) => {
  const intl = useIntl()

  const departureTime = splitDateTime(flight?.atd || flight?.etd || '')
  const arrivalTime = splitDateTime(flight?.ata || flight?.eta || '')

  return (
    <div className=' fw-bold text-gray-800 fs-6 d-flex flex-column gap-4 col-12'>
      {flight.layover_duration && (
        <div className='border border-1 border-gray-300 rounded-2 px-6 py-4 fw-bolder text-gray-900'>
          {intl.formatMessage({id: 'LAYOVER'})}:{' '}
          {durationToString(splitHours(flight.layover_duration), intl)}
        </div>
      )}
      <div className='bg-primary-active rounded-2 p-6'>
        <div className='row g-6'>
          <div className='col-12 col-md-3 d-flex justify-content-between align-items-center gap-3'>
            <div className='d-flex flex-column gap-4'>
              <div>
                {intl.formatMessage({id: 'FLIGHT_NO'})}:{' '}
                <span className='fw-bolder text-gray-900'>{flight.flight_number}</span>
              </div>
              <div>
                {intl.formatMessage({id: 'STATUS'})}:{' '}
                <span className='fw-bolder text-gray-900'>{flight.status}</span>
              </div>
            </div>
            <div className='d-flex flex-column align-items-center'>
              <KTSVG
                path='/media/gori/a1/flight.svg'
                className='svg-icon-1 text-gray-700 rotate-90'
                style={{transform: 'rotate(90deg)'}}
              />
              <div className='border-bottom border-dashed border-1 border-gray-700 h-40px'></div>
              <div className='w-8px h-8px rounded-circle bg-gray-700'></div>
            </div>
          </div>
          <div className='col-12 col-md-3 d-flex flex-column align-items-center justify-content-between'>
            {!!departureTime && (
              <div className='d-flex gap-6'>
                <div>{departureTime?.date}</div>
                <div>{`${departureTime?.time} ${departureTime?.timezone}`}</div>
              </div>
            )}
            <div className='text-gray-500 text-center'>
              {isNumber(flight?.est_duration)
                ? `${durationToString(splitHours(flight?.est_duration), intl)} ${intl.formatMessage(
                    {id: 'TRAVEL_TIME'}
                  )}`
                : ''}
            </div>
            {!!arrivalTime && (
              <div className='d-flex gap-6'>
                <div>{arrivalTime?.date}</div>
                <div>{`${arrivalTime?.time} ${arrivalTime?.timezone}`}</div>
              </div>
            )}
          </div>
          <div className='col-12 col-md-6 d-flex flex-column justify-content-between px-6'>
            <div className='fw-bold'>
              {flight.origin_name}{' '}
              <span className='fw-bolder text-gray-900'>({flight.origin_iata})</span>
            </div>
            <div className='fw-bold'>
              {flight.destination_name}{' '}
              <span className='fw-bolder text-gray-900'>({flight.destination_iata})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
